const { host } = window.location;

export const environment = {
    production: true,
    hmr: false,
    stage: false,
    baseApiUrl: `https://${host}/api/`,
    baseGraphQlUrl: `https://${host}/graphql`,
    notificationsApiUrl: `https://${host}/notifications/`,
    authApiUrl: `https://${host}/auth`,
};